import { computed } from "vue";
import { empty } from "../../../helpers";
import store from "../../store";
import useProduct from "./useProduct";

export default function useLover() {
  const defaultNames = "Patrik + Zuzka";
  const defaultDate = "20.04.2019";
  const defaultPlace = "Barcelona";
  const { updateProductAttributeValue } = useProduct();

  // computed
  const names = computed(() => getComputedAttribute(defaultNames, "names"));
  const date = computed(() => getComputedAttribute(defaultDate, "date"));
  const place = computed(() => getComputedAttribute(defaultPlace, "place"));

  function getComputedAttribute(defaultText, attribute) {
    const name = store.getters["product/getProduct"].attributes[attribute];

    return empty(name) ? defaultText : name;
  }

  // [CUSTOM]
  function updatedLoverType(index) {
    const type =
      store.getters["product/getAttributes"]["loverType"].attribute_values[
        index
      ];
    let product = store.getters["product/getProduct"];

    updateProductAttributeValue("loverType", type);
    // for editing - preset index
    type.index = index;
    product.attribute_values["loverType"] = type;
    // clear attribute values
    delete product.attributes.names;
    delete product.attributes.date;
    delete product.attributes.place;

    store.commit("product/SET_PRODUCT", product);
  }

  function updatedLoverShape(index) {
    let product = store.getters["product/getProduct"];
    const type =
      store.getters["product/getAttributes"]["loverShape"].attribute_values[index];

    updateProductAttributeValue("loverShape", type);

    type.index = index;
    product.attribute_values["loverShape"] = type;

    store.commit("product/SET_PRODUCT", product);
  }

  function hasElement(product, attribute, element) {
    return (
      product.attribute_values[attribute] &&
      product.attribute_values[attribute].preferences.elements.includes(element)
    );
  }

  return {
    updatedLoverShape,
    updatedLoverType,
    defaultNames,
    defaultDate,
    defaultPlace,
    names,
    date,
    place,
    hasElement,
  };
}
